import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IGetHojaDeVidaJoinInfo, ITipoTramite, VwTramDoc } from '../../../../shared/interfaces/database/configuracion';
import { TipoTramiteService } from '../../../../services/database/tipoTramite.service';
import { TramDocService } from '../../../../services/database/tramDocService.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TableModule, TableRowExpandEvent } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { AdminTipoTramiteActividadComponent } from '../admin-tipo-tramite-actividad/admin-tipo-tramite-actividad.component';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import {
  AccessRole, ButtonColumnType, CustomTableComponent, DataColumnType, IColumns,
  ICustomTable, LoadingPanelService, LocalService,
  CustomAlertComponent, AlertIcon, AlertService,
  Severity,
  CustomTitle
} from 'lib-base';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin, lastValueFrom } from 'rxjs';
import { MultiSelectModule } from 'primeng/multiselect';
import { TipoTramiteCostoComponent } from "../tipo-tramite-costo/tipo-tramite-costo.component";
import { AdminTipoTramiteHistorialComponent } from './admin-tipo-tramite-historial/admin-tipo-tramite-historial.component';
import { TramiteWizardComponent } from '../../tramite-wizard/tramite-wizard.component';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AlertasDialogComponent } from '../../../../components/custom-work/other/alertas-dialog/alertas-dialog.component';

@Component({
  selector: 'app-admin-tipo-tramite',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, TranslateModule, AdminTipoTramiteHistorialComponent,
    TableModule, ButtonModule, TabViewModule, DialogModule, ConfirmPopupModule, TramiteWizardComponent,
    AdminTipoTramiteActividadComponent, MultiSelectModule, TipoTramiteCostoComponent,
    CustomTableComponent, CustomAlertComponent, TranslateModule, AlertasDialogComponent],
  providers: [ConfirmationService],
  templateUrl: './admin-tipo-tramite.component.html',
  styleUrls: ['./admin-tipo-tramite.component.scss']
})
export class AdminTipoTramiteComponent implements OnInit {

  tiposTramites !: ITipoTramite[];

  formTitle: string = "Nuevo";
  displayTipoTramiteModal = false;
  columns !: IColumns[];
  role = AccessRole;
  translations: any = {};

  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(TramiteWizardComponent, { static: false }) tramiteWizardComponent !: TramiteWizardComponent;
  @ViewChild(AdminTipoTramiteHistorialComponent) historico !: AdminTipoTramiteHistorialComponent;

  //Alertas
  @ViewChild(AlertasDialogComponent) alertasDialog !: AlertasDialogComponent;

  constructor(private readonly _tt: TipoTramiteService, private readonly _td: TramDocService, private readonly _lps: LoadingPanelService,
    private readonly _als: AlertService, private readonly _ms: MessageService, private readonly _cs: ConfirmationService,
    public readonly ls: LocalService, private readonly _t: TranslateService, private readonly _router: Router) {
  }

  ngOnInit() {
    this.translate().then(() => this.configTable());
    this.getTiposTramites();
  }

  private async translate(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      actividades: this._t.get('common.actividades'),
      documentos: this._t.get('common.documentos'),
      costos: this._t.get('common.costos'),
      title: this._t.get('components.app-admin-tramites.app-admin-tipo-tramite.title'),
      nombre: this._t.get('common.nombre'),
      descripcionBreve: this._t.get('common.descripcionBreve'),
      categorizacion: this._t.get('common.categorizacion'),
      plazo: this._t.get('common.plazo'),
      tipoDePlazo: this._t.get('common.tipoDePlazo'),
      costo: this._t.get('common.costo'),
      requierePago: this._t.get('common.requierePago'),
      produccion: this._t.get('common.produccion'),
      hojaDeVidaTramite: this._t.get('common.hojaDeVidaTramite'),
      formulario: this._t.get('common.formulario'),
      fuenteDePago: this._t.get('common.fuenteDePago'),
      tieneFuenteDeCreacion: this._t.get('common.tieneFuenteDeCreacion'),
      exito: this._t.get('common.exito'),
      nuevoTipoTramite: this._t.get('msg.nuevoTipoTramite'),
      editarTipoTramite: this._t.get('msg.editarTipoTramite'),
      registroActualizado: this._t.get('msg.registroActualizado'),
      estasSeguroEliminarTramite: this._t.get('msg.estasSeguroEliminarTramite'),
      tipoTramiteEliminado: this._t.get('msg.tipoTramiteEliminado'),
      dependencia: this._t.get('common.dependencia'),
      tramite: this._t.get('common.tramite'),
      buttonCerrar: this._t.get('form.button.cerrar'),
      publicadoPortal: this._t.get('components.app-admin-tramites.app-admin-tipo-tramite.publicado-portal-tramite'),
      iac: this._t.get('common.iac'),
      alertas: this._t.get('common.alertas'),
    }));
  }

  configTable() {
    this.customTable = {
      header: {
        //esto existe para las columnas opcionales
      },
      columns: [
        {
          field: 'expand',
          header: '',
          class: 'p-button-info',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'dependencia',
          header: this.translations.dependencia,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          width: '12rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'descripcion',
          header: this.translations.nombre,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          columnFilter: true,
          width: '12rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'descripcionBreve',
          header: this.translations.descripcionBreve,
          width: '10rem',
          class:'font-13',
          truncate: true,
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'categorizacionDescripcion',
          header: this.translations.categorizacion,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          columnFilter: false,
          width: '4rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'costo',
          header: this.translations.costo,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          columnFilter: false,
          width: '8rem',
          dataType: DataColumnType.MONEY,
          optional: true
        },
        {
          field: 'requierePago',
          header: this.translations.requierePago,
          sort: true,
          width: '5rem',
          dataType: DataColumnType.CHECK
        },
        {
          field: 'formularioNombre',
          header: this.translations.formulario,
          label: this.translations.formulario,
          columnFilter: true,
          icon: 'pi pi-folder-open',
          width: '10rem',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          truncate: true,
          buttonType: ButtonColumnType.TEXT,
          onClick: (event: Event, data: ITipoTramite) => this.openFormulario(data),
        },
        {
          field: 'conceptosTramitesDescripcion',
          header: this.translations.fuenteDePago,
          sort: false,
          columnFilter: true,
          width: '9rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'iac',
          header: this.translations.iac,
          sort: false,
          columnFilter: true,
          width: '9rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'tieneFuenteDeCreacion',
          header: this.translations.tieneFuenteDeCreacion,
          sort: false,
          columnFilter: true,
          width: '6rem',
          dataType: DataColumnType.CHECK,
          optional: true
        },
        {
          field: 'correo',
          header: 'Correo',
          sort: true,
          columnFilter: true,
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'direccion',
          header: 'Dirección',
          sort: true,
          columnFilter: true,
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'horariosAtencion',
          header: 'Horarios de Atención',
          sort: false,
          columnFilter: true,
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'nombreBanco',
          header: 'Nombre Banco',
          sort: true,
          columnFilter: true,
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'norma',
          header: 'Norma',
          sort: true,
          columnFilter: true,
          width: '8rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'numeroCuenta',
          header: 'Número de Cuenta',
          sort: true,
          columnFilter: true,
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'observaciones',
          header: 'Observaciones',
          sort: false,
          columnFilter: true,
          width: '12rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'periodo',
          header: 'Periodo',
          sort: true,
          columnFilter: true,
          width: '8rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'relacion',
          header: 'Relación',
          sort: true,
          columnFilter: true,
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'telefono',
          header: 'Teléfono',
          sort: true,
          columnFilter: true,
          width: '8rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'tipoCuenta',
          header: 'Tipo de Cuenta',
          sort: true,
          columnFilter: true,
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'requisitos',
          header: 'Requisitos',
          sort: false,
          columnFilter: true,
          width: '12rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'ruta',
          header: 'Ruta',
          sort: true,
          columnFilter: true,
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'fechaActualizacion',
          header: 'Fecha de Actualización',
          sort: true,
          columnFilter: true,
          width: '10rem',
          dataType: DataColumnType.DATE,
          optional: true
        },
        {
          field: 'fechaCreacion',
          header: 'Fecha de Creación',
          sort: true,
          columnFilter: true,
          width: '10rem',
          dataType: DataColumnType.DATE,
          optional: true
        },
        {
          field: 'urlTramite',
          header: 'URL del Trámite',
          sort: false,
          columnFilter: true,
          width: '10rem',
          dataType: DataColumnType.TEXT,
          optional: true
        },
        {
          field: 'produccion',
          header: this.translations.produccion,
          sort: true,
          class: 'button-edit p-button-outlined',
          width: '6rem',
          buttonType: ButtonColumnType.CHECK,
          onClick: (event: Event, data: ITipoTramite) => this.cambiarEstadoProduccion(data),
        },
        {
          field: 'warnings',
          header: this.translations.alertas,
          icon: 'pi pi-info-circle',
          class: 'button-edit p-button-outlined pt-2 pb-2 pr-0 pl-0',
          width: '0rem',
          getSeverity: (data: ITipoTramite) => this.alertasGetSeverity(data),
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: ITipoTramite) => this.alertasMostrar(data),
        },
        {
          field: 'abrir',
          header: '',
          icon: 'pi pi-history',
          class: 'button-edit p-button-outlined pt-2 pb-2 pr-0 pl-0',
          width: '0rem',
          severity: 'info',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: ITipoTramite) => this.abrirHistorial(data),
        },
        {
          field: 'edit',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0 pr-0',
          buttonType: ButtonColumnType.EDIT,
          onClick: (event: Event, data: ITipoTramite) => this.openEditTipoTramiteModal(data),
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0',
          buttonType: ButtonColumnType.DELETE,
          onClick: (event: Event, data: ITipoTramite) => this.deleteConfirmation(event, data),
          disabled: !this.ls.hasRole(this.role.ADMIN_SEC),
          headerBtn: {
            icon: 'pi pi-history',
            class: 'pt-2 pb-2 pl-0 pr-0',
            severity: 'info',
            onClick: (event: Event) => this.abrirHistorialEliminado(),
          }
        }
      ],
      settings: {
        columnToggle: {
          showColumnToggle: true,
          maxSelectedLabels: 7
        }
      }
    } as ICustomTable;
  }

  onTramitesRowExpand(event: TableRowExpandEvent) {
    this.getTramDocs(event.data);
  }

  openNewTipoTramiteModal() {
    this.formTitle = this.translations.nuevoTipoTramite;
    this.displayTipoTramiteModal = true;
  }

  openEditTipoTramiteModal(tramite: ITipoTramite) {
    this.formTitle = this.translations.editarTipoTramite;
    this.displayTipoTramiteModal = true;
    this._lps.show(true);
    //this timeout makes sure the components has been initialized when calling the function.
    this._tt.getHojaDeVidaJoinInfo(tramite.id).subscribe({
      next: (data: IGetHojaDeVidaJoinInfo) => {
        this._lps.hide();
        this.tramiteWizardComponent.loadWizard(tramite, data);
      }
    });
  }

  deleteConfirmation(event: Event, data: ITipoTramite) {
    this._cs.confirm({
      target: event.target as EventTarget,
      message: this.translations.estasSeguroEliminarTramite,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteTipoTramite(data.id)
      },
      reject: () => {

      }
    });
  }

  onFinalizado() {
    this.tiposTramites = [];
    this.getTiposTramites();
    this.displayTipoTramiteModal = false;
  }

  abrirHistorial(data: ITipoTramite): void {
    this.historico.show(data.id);
  }

  abrirHistorialEliminado(): void {
    this.historico.showEliminado();
  }

  private cambiarEstadoProduccion(data: ITipoTramite) {
    this.setProduccion(data.id, !data.produccion).then(() => {
      if (!data.produccion) {
        this._als.show({
          data: {
            showIcon: false,
            icon: AlertIcon.SUCCESS,
            title: '',
            html: `
         <div class="w-100">
            <h2 class="text-gray uppercase">${this.translations.tramite}</h2>
            <h2 class="uppercase">${data.descripcion}</h2>
            <p class="text-2xl mb-2">${this.translations.publicadoPortal}</p>
         </div>
        `,
            showAccept: true,
            positionBtn: 'right',
            acceptButton: {
              label: this.translations.buttonCerrar,
              class: 'border-rounded-xl bg-indigo-600 hover:bg-indigo-400',
            }
          },
          autoClose: true,
          breakpoints: {
            '1800px': '30vw',
            '1600px': '30vw',
            '1400px': '40vw',
            '960px': '50vw',
            '640px': '90vw'
          },
          position: 'top-right',
        });
      } else {
        this._ms.add({ severity: 'info', summary: this.translations.registroActualizado });
      }
    });
  }

  private openFormulario(data: ITipoTramite): void {
    const url = `#/configuracion/formulario/edit/${data.formularioId}`
    window.open(url, '_blank');
  }
  //#Region API Calls

  getTiposTramites() {
    if (this.tiposTramites && this.tiposTramites.length > 0) return;
    this._tt.getTipoTramites().subscribe({
      next: (data: ITipoTramite[]) => {
        this.tiposTramites = data;
        this.customTableComponent.data = data;
      }
    });
  }

  getTramDocs(tipoTramite: any) {
    if (tipoTramite.tramDocs) return;
    tipoTramite.tramDocs = [];
    this._td.getTramDocsByTipotramiteId(tipoTramite.id).subscribe({
      next: (tramDocs: VwTramDoc[]) => {
        tipoTramite.tramDocs.push(...tramDocs);
      },
      error: (error: HttpErrorResponse) => {
        this._ms.add({ severity: 'error', summary: error.error, detail: error.message });
      }
    });
  }

  deleteTipoTramite(id: number) {
    this._lps.show(true);
    this._tt.deleteTipoTramite(id).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: this.translations.exito, detail: this.translations.tipoTramiteEliminado });
        this.tiposTramites = [];
        this.getTiposTramites();
      }
    });
  }

  async setProduccion(id: number, produccion: boolean) {
    this._lps.show(true);
    return await lastValueFrom(this._tt.setProduccion(id, produccion))
      .then((response: boolean) => {
        this._lps.hide();
        this.tiposTramites = [];
        this.getTiposTramites();
      });
  }
  //#EndRegion

  //#region alertas
  alertasMostrar(data: ITipoTramite): void {
    let alertas: String[] = [];
    if (!data.formularioIsLatest)
      alertas.push(this._t.instant('msg.alertaFormularioNoReciente'));    
    if (!data.componentesPersonalizadosIsLatest && data.componentesPersonalizadosId)
      alertas.push(this._t.instant('msg.alertaComponentePersonalizadoNoReciente')); 
    if(!data.respuestaDinamicaPlantillaIsLatest && data.respuestaDinamicaPlantillaId)
      alertas.push(this._t.instant('msg.alertaCorreoPlantillaNoReciente'));
    if(!data.controlDeTiempoIsLatest && data.controlDeTiempoId)
      alertas.push(this._t.instant('msg.controlDeTiempoNoReciente'));
    this.alertasDialog.show(alertas);
  }

  alertasGetSeverity(data: ITipoTramite): Severity {
    let severity: Severity = 'success';
    if (!data.formularioIsLatest)
      severity = 'warning';    
    if(!data.componentesPersonalizadosIsLatest && data.componentesPersonalizadosId)
      severity = 'warning';
    if(!data.respuestaDinamicaPlantillaIsLatest && data.respuestaDinamicaPlantillaId)
      severity = 'warning';
    if(!data.controlDeTiempoIsLatest && data.controlDeTiempoId)
      severity = 'warning';
    return severity;
  }
  //#endregion alertas
}
